import {
    createMedia,
    deleteMedia,
    getMediaList,
    getMedia,
    updateMedia,

} from '../../api/mediaApi'
import {Message} from "element-ui";
import router from "../../router";
import {updateTag} from "../../api/tagsApi";

const state = {
    image: null,
    mediaList: [],
    meta: {},
    media: {}
}

const getters = {
    getMediaList: state => state.mediaList,
    getMediaMeta: state => state.meta,
    getMedia: state => state.media
}

const actions = {
    createMedia({ commit }, file) {
        return new Promise((resolve, reject) => {
            createMedia(file)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    deleteMedia({ commit }, params) {
        return new Promise((resolve, reject) => {
            deleteMedia(params)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    getMediaList: ({commit}, params) => {
        getMediaList(params).then(resp => {
            commit('SET_MEDIA', resp)
        }).catch(err => console.log(err))
    },
    getMedia: ({commit, dispatch}, idMedia) => {
        getMedia(idMedia).then(r => {
            commit('SET_MEDIA_SHOW', r.data)
        }).catch(err => {
            if (err.response.status === 404) {
                console.log(router.push({name: 'not-found'}))
            }
        })
    },
    updateMedia: ({commit}, payload) => {
        updateMedia(payload).then(r => {
            Message({
                message: 'Data saved',
                type: 'success',
                duration: 5 * 1000,
            })
        }).catch(err => console.dir(err))
    },
}

const mutations = {
    SET_MEDIA: (state, payload) => {
        state.mediaList = payload.data
        state.meta = payload.meta
    },
    SET_MEDIA_SHOW: (state, payload) => {
        state.media = payload
    },
}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
















